import store from "..";
import API from "../../api";
import {
  AUTH_TOKEN_REFRESH,
  LOGIN_SUCCESS,
  LOGOUT,
  AUTH_UPDATE_SETTING_DATETIME,
  AUTH_NOTIFICATION_REFRESH,
  START_REFRESH_INTERVAL,
  STOP_REFRESH_INTERVAL,
} from "../../constants/actionTypes";
import { API_REFRESH_TOKEN } from "../../constants/api";
import { REFRESH_INTERVAL } from "../../constants/app";

//Action process when user login successfully
const loginSuccess = (response) => {
  const token = response.acesss;
  API.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  return {
    type: LOGIN_SUCCESS,
    payload: response,
  };
};

// Acction process when user process logout
const logoutSuccess = () => {
  delete API.defaults.headers.common["Authorization"];
  return {
    type: LOGOUT,
    payload: {},
  };
};

const startRefreshInterval = () => {
  let intervalId = store.getState().auth.intervalId;
  if (intervalId) {
    clearInterval(intervalId);
  }
  intervalId = setInterval(async () => {
    const refreshToken = store.getState().auth?.refresh_token;
    if (refreshToken) {
      try {
        const response = await API.post(API_REFRESH_TOKEN, {
          refresh: refreshToken ?? "no-token",
        });
        const accessToken = response.data.access;
        store.dispatch(refreshAccessToken(accessToken));
      } catch (e) {
        if (e.response.status === 401) {
          store.dispatch(logoutSuccess());
        }
      }
    }
  }, REFRESH_INTERVAL);
  return {
    type: START_REFRESH_INTERVAL,
    payload: intervalId,
  };
};

const stopRefreshInterval = () => {
  let intervalId = store.getState().auth.intervalId;
  if (intervalId) {
    clearInterval(intervalId);
  }
  return {
    type: STOP_REFRESH_INTERVAL,
  };
};

//Action to process refresh access token
const refreshAccessToken = (token) => {
  return {
    type: AUTH_TOKEN_REFRESH,
    payload: token,
  };
};

//Action to process update last settings datetime in user
const updateLastSettingDateTime = (last_update_datetime) => {
  return {
    type: AUTH_UPDATE_SETTING_DATETIME,
    payload: last_update_datetime,
  };
};

//Action to process refresh notifications
const refreshNotifications = (notifications) => {
  return {
    type: AUTH_NOTIFICATION_REFRESH,
    payload: notifications,
  };
};

export {
  loginSuccess,
  logoutSuccess,
  refreshAccessToken,
  updateLastSettingDateTime,
  refreshNotifications,
  startRefreshInterval,
  stopRefreshInterval,
};
